<template>
  <div class="notice atb-flex atb-flex-column">
    <div class="tab">
      <tab-pane :tab-list="tabList" @getCurrent="getCurrent"></tab-pane>
    </div>
    <div v-show="currentTab == 0" class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList('resetPage')" @submit.native.prevent>
          <el-form-item label="消息类型">
             <common-select ref="msgObjectType" v-model="searchParam.MsgObjectType" :list="msgTypeList"
             optLabel="label" optValue="value" placeholder="消息类型"></common-select>
            <!-- <el-select clearable v-model="searchParam.MsgObjectType" placeholder="消息类型">
              <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="发信人">
            <el-input v-model="searchParam.SendNo" placeholder="名字/工号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <vxe-table stripe highlight-hover-row highlight-current-row class="atb-table" border="inner" height="100%" auto-resize :data="tableData" ref="unHandle" @cell-click="goDetail">
          <vxe-table-column type="seq" width="60" title="NO."></vxe-table-column>
          <vxe-table-column field="sendName" title="发信人" width="120"></vxe-table-column>
          <vxe-table-column field="sendNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="msgContent" title="主题" min-width="300"></vxe-table-column>
          <vxe-table-column field="msgObjectType" title="消息类型" min-width="120">
            <template #default="{ row }">{{
              msgTypeList.find((t) => t.value === row.msgObjectType) ? msgTypeList.find((t) => t.value === row.msgObjectType).label : ''
            }}</template>
          </vxe-table-column>
          <vxe-table-column field="dealDate" title="时间" min-width="165">
            <template #default="{row}">
              <span>{{ row.creationTime ? XEUtils.toDateString(new Date(row.creationTime)) : '' }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <vxe-pager
          background
          :current-page.sync="page.PageIndex"
          :page-size.sync="page.PageSize"
          :total="total"
          height="100%"
          @page-change="unHandlePageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <div v-show="currentTab == 1" class="atb-content-bg atb-flex atb-flex-column">
      <div class="search">
        <el-form :inline="true" :model="handledSearchParam" class="atb-input" @keyup.enter.native="getHandledList('resetPage')" @submit.native.prevent>
          <el-form-item label="消息类型">
             <common-select ref="msgObjectTypeApproved" v-model="handledSearchParam.MsgObjectType" :list="msgTypeList"
             optLabel="label" optValue="value" placeholder="消息类型"></common-select>
            <!-- <el-select clearable v-model="handledSearchParam.MsgObjectType" placeholder="消息类型">
              <el-option v-for="item in msgTypeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select> -->
          </el-form-item>
          <el-form-item label="发信人">
            <el-input v-model="handledSearchParam.SendNo" placeholder="名字/工号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getHandledList('resetPage')">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="table-content">
        <vxe-table
          stripe
          class="atb-table"
          border="inner"
          height="100%"
          ref="handled"
          auto-resize
          highlight-hover-row
          highlight-current-row
          @checkbox-all="handledSelectAll"
          @checkbox-change="handledSelectChange"
          :data="handledTableData"
          @cell-click="goDetail"
        >
          <vxe-table-column type="checkbox" width="50"></vxe-table-column>
          <vxe-table-column type="seq" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="sendName" title="发信人" width="120"></vxe-table-column>
          <vxe-table-column field="sendNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="msgContent" title="主题" min-width="300"></vxe-table-column>
          <vxe-table-column field="msgObjectType" title="消息类型" min-width="120">
            <template #default="{ row }">{{
              msgTypeList.find((t) => t.value === row.msgObjectType) ? msgTypeList.find((t) => t.value === row.msgObjectType).label : ''
            }}</template>
          </vxe-table-column>
          <vxe-table-column field="dealDate" title="时间" min-width="165">
            <template #default="{row}">
              <span>{{ row.dealDate ? XEUtils.toDateString(new Date(row.dealDate)) : '' }}</span>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div class="page-con atb-flex atb-flex-justify-end">
        <el-button :disabled="handleDelete" type="primary" @click="showDelTip = true" class="atb-batch">批量删除</el-button>
        <vxe-pager
          background
          :current-page.sync="handledPage.PageIndex"
          :page-size.sync="handledPage.PageSize"
          :total="handledTotal"
          height="100%"
          @page-change="handledPageChange"
          :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
        >
        </vxe-pager>
      </div>
    </div>
    <el-dialog title="批量处理" :visible.sync="showHandle" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定全部处理吗?</h2>
        <p>处理过之后就不能再修改</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="confirmHandle">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showHandle = false">取消</el-button>
      </span>
    </el-dialog>
    <common-dialog ref="modifyApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :extend="dialogContent.extend"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="taskApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName" 
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="yearApprove" :title="dialogContent.title" width="950px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <common-dialog ref="transfer" :title="transferContent.title" width="900px" showClose>
      <template slot="content">
        <component v-bind:is="transferContent.componentName" :role="transferContent.role" :msg="transferContent.msg" @submitSuccess="getList()"></component>
      </template>
    </common-dialog>
    <common-dialog ref="todoWorkApprove" :title="dialogContent.title" width="1000px" showClose>
      <template slot="content">
        <component
          v-bind:is="dialogContent.componentName"
          :msgObjectId="dialogContent.msgObjectId"
          :msgObjectChildId="dialogContent.msgObjectChildId"
          :role="dialogContent.role"
          :msgId="dialogContent.msgId"
          :sendName="dialogContent.sendName"
          :workType="dialogContent.workType"
          :sendAction="dialogContent.sendAction"
          @submitSuccess="getList()"
        ></component>
      </template>
    </common-dialog>
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>已删除的数据项不能撤回</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="deleteAll">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import XEUtils from 'xe-utils';

export default {
  components: {
    modifyApprove: () => import('./modifyApprove.vue'),
    taskApprove: () => import('./taskApprove.vue'),
    yearApprove: () => import('./yearApprove.vue'),
    transfer: () => import('./transfer.vue'),
    todoWorkApprove: () => import('./todoWorkApprove.vue'),
  },
  name: 'index',
  data() {
    return {
      XEUtils: XEUtils,
      activeName: 'second',
      currentTab: 0,
      showHandle: false,
      handleDelete: true,
      enableHandle: true,
      tabList: [
        {
          label: '待审批',
          id: 0,
        },
        {
          label: '已审批',
          id: 1,
        },
      ],
      searchParam: {
        MsgCategory: 3,
        Status: null,
        MsgObjectType: '',
      },
      page: {
        PageIndex: 1,
        PageSize: 10,
      },
      total: 0,
      tableData: [],
      unHandleList: [],

      handledSearchParam: {
        MsgCategory: 3,
        Status: null,
        MsgObjectType: '',
      },
      handledPage: {
        PageIndex: 1,
        PageSize: 10,
      },
      handledTotal: 0,
      handledTableData: [],
      handledList: [],
      dialogContent: {},
      transferContent: {},
      msgTypeList: [],
      that:this,
      showDelTip:false,
    };
  },
  created() {
    this.getList();
    this.getMsgType();
  },
  mounted() {},
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    },
    getMsgType() {
      this.$ajax
        .get(this.$api.Identity.BasicData.all, { ItemType: 'MsgObjectType' })
        .then((res) => {
          this.msgTypeList = this.filterMsgType(res.data.rows || []);
        })
        .catch(() => {});
    },
    getList(resetPage) {
      if(resetPage){
        this.page.PageIndex = 1;
      }
      let param = Object.assign({}, this.searchParam, this.page);
      this.$ajax.get(this.$api.notice.list, param).then((res) => {
        this.tableData = res.data.rows;
        this.total = res.data.total;
      });
    },
    getHandledList(resetPage) {
      if(resetPage){
        this.handledPage.PageIndex = 1;
      }
      let param = Object.assign({}, this.handledSearchParam, this.handledPage);
      this.$ajax.get(this.$api.notice.list, param).then((res) => {
        this.handledTableData = res.data.rows;
        this.handledTotal = res.data.total;
      });
    },
    getCurrent(item) {
      this.currentTab = item.data.id;
      if (this.currentTab === 0) {
        this.searchParam.status = this.currentTab;
        this.getList();
      } else {
        this.handledSearchParam.status = this.currentTab;
        this.getHandledList();
      }
    },
    unHandlePageChange({ currentPage }) {
      this.page.PageIndex = currentPage;
      this.getList();
    },
    goDetail({row,triggerCheckbox}) {
      if(triggerCheckbox){
        return false;
      }
      switch (row.msgObjectType) {
        case 'WeekWork':
          this.$router.push({
            path: '/personal/week/detail',
            query: {
              id: row.msgObjectId,
              status: row.status,
              childIds: row.msgObjectChildId?row.msgObjectChildId.join(','):'',
              editStatus: row.status===0? 'approve': '',
              msgId: row.id,
            },
          });
          break;
        case 'MonthWork':
          this.$router.push({
            path: '/personal/month/detail',
            query: {
              id: row.msgObjectId,
              status: row.status,
              childIds: row.msgObjectChildId?row.msgObjectChildId.join(','):'',
              editStatus: row.status===0? 'approve': '',
              msgId: row.id,
            },
          });
          break;
        // case 'DayWork':
        //   this.$router.push({
        //     path: '/personal/day/detail',
        //     query: {
        //       id: row.msgObjectId,
        //       status: row.status,
        //       editStatus: row.status===0? 'approve': '',
        //     },
        //   });
        //   break;
        case 'YearPlan':
          const yearExtend = JSON.parse(row.extend || '{}');
          const query = {
            id: row.msgObjectId,
            status: row.status,
            editStatus: row.status === 0 ? 'approve' : '',
            childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
            msgId: row.id,
          };
          if (yearExtend.Version) {
            this.$router.push({
              path: '/personal/year-plan/detail-next',
              query,
            });
          } else {
            this.$router.push({
              path: '/personal/year-plan/detail',
              query,
            });
          }
          break;
        case 'ModifyWork':
          this.dialogContent = {
            title: '修订审批',
            componentName: 'modifyApprove',
            msgObjectId: row.msgObjectId,
            role: row.sendAction === 'WorkModifyCommit' && this.currentTab !== 1 ? 1 : 0,
            extend: row.extend
          };
          this.$refs.modifyApprove.show();
          break;
        case 'PublishMonthWork':
          this.dialogContent = {
            title: '新增工作发布',
            componentName: 'taskApprove',
            msgObjectId: row.msgObjectChildId,
            role: row.sendAction === 'PublishMonthWorkCommit' && this.currentTab !== 1 ? 1 : 0,
            msgId: row.id,
            sendName:JSON.parse(row.extend).CreatorUserName
          };
          this.$refs.taskApprove.show();
          break;
        case 'PublishYearWork':
          this.dialogContent = {
            title: '年计划修订',
            componentName: 'yearApprove',
            msgObjectId: row.msgObjectChildId,
            role: row.sendAction === 'PublishYearWorkCommit' && this.currentTab !== 1 ? 1 : 0,
            msgId: row.id,
            sendName:JSON.parse(row.extend).CreatorUserName
          };
          this.$refs.yearApprove.show();
          break;
        case 'TransferWork':
          this.transferContent = {
            title: '转移工作审批',
            componentName: 'transfer',
            msg: row,
            role: this.currentTab !== 1 ? 1 : 0,
          };
          this.$refs.transfer.show();
          break;
        case 'HandoverWork':
          this.transferContent = {
            title: '交接工作审批',
            componentName: 'transfer',
            msg: row,
            role: this.currentTab !== 1 ? 1 : 0,
          };
          this.$refs.transfer.show();
          break;
        case 'OEC':
          let tab;
          if (['OECAmendmentCommit', 'OECAmendmentCommitPassed', 'OECAmendmentCommitRejected'].includes(row.sendAction)) {
            tab = 3;
          }
          this.$router.push({
            path: '/manage/declare',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              role: this.currentTab !== 1 ? 1 : 2,
              date: row.extend ? JSON.parse(row.extend).Year + '-' + JSON.parse(row.extend).Month : '',
              tab,
            },
          });
          break;
        case 'PeriodResult':
          this.$router.push({
            path: '/period/periodresult/index',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              role: this.currentTab === 0 ? 1 : 2,
              year: row.extend ? JSON.parse(row.extend).Year : '',
              period: row.extend ? JSON.parse(row.extend).Period : '',
              editStatus: 'approve'
            },
          });
          break;
        case 'WorkScore':
          this.$router.push({
            path: '/personal/workscore/detail',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              id: row.msgObjectId,
              editStatus: 'approve'
            },
          });
          break;
        case 'ImportantSort':
          this.$router.push({
            path: '/period/importance-sort/index',
            query: {
              wkNo: row.sendNo,
              msgId: row.id,
              role: this.currentTab === 0 ? 1 : 2,
              editStatus: 'approve'
            },
          });
          break;
        case 'PublishMonthTodoWork':
          this.dialogContent = {
            title: '工作待办发布月计划审批',
            componentName: 'todoWorkApprove',
            msgObjectId: row.msgObjectId,
            msgObjectChildId: row.msgObjectChildId,
            role: this.currentTab === 0 ? 1 : 0,
            msgId: row.id,
            sendName: JSON.parse(row.extend).CreatorUserName,
            workType: 'Month',
            sendAction: row.sendAction,
          };
          this.$refs.todoWorkApprove.show();
          break;
        case 'PublishWeekTodoWork':
          this.dialogContent = {
            title: '工作待办发布周计划审批',
            componentName: 'todoWorkApprove',
            msgObjectId: row.msgObjectId,
            msgObjectChildId: row.msgObjectChildId,
            role: this.currentTab === 0 ? 1 : 0,
            msgId: row.id,
            sendName: JSON.parse(row.extend).CreatorUserName,
            workType: 'Week',
            sendAction: row.sendAction,
          };
          this.$refs.todoWorkApprove.show();
          break;

        case 'ResponseWork':
          this.$router.push({
            path: '/response/personal/detail',
            query: {
              id: row.msgObjectId,
              msgStatus: row.status,
              editStatus: row.status === 0 ? 'approve' : '',
              childIds: row.msgObjectChildId ? row.msgObjectChildId.join(',') : '',
              msgId: row.id,
            },
          });
          break;
      }
    },
    handledSelectAll({ checked, records }) {
      this.handleDelete = !checked;
      this.handledList = records.map((val) => {
        const { id } = val;
        return id;
      });
    },
    handledSelectChange({ records }) {
      this.handledList = records.map((val) => {
        const { id } = val;
        return id;
      });
      if (this.handledList.length > 0) {
        this.handleDelete = false;
      } else {
        this.handleDelete = true;
      }
    },
    handledPageChange({ currentPage }) {
      this.handledPage.PageIndex = currentPage;
      this.getHandledList();
    },
    deleteAll() {
      this.$ajax.put(this.$api.notice.delete, this.handledList).then(() => {
        this.showDelTip=false;
        this.$message.success('删除成功');
        this.getHandledList();
      });
    },
    deleteTip() {
      this.showDelTip=true;
    },
  },
  activated() {
    if (this.currentTab == 0){
      this.getList();
    }else {
      this.getList("resetPage");
    }
  }
};
</script>
<style scoped lang="scss">
.notice {
  height: 100%;
  .atb-content-bg {
    margin-top: 15px;
    padding: 20px;
    flex: 1;
  }
  ::v-deep .tab{
    margin-top: -3px;
  }
  ::v-deep .el-dialog__body {
    padding-top: 33px !important;
    text-align: center;
    h2 {
      font-size: 18px;
      color: $--color-text-primary;
      font-weight: bold;
      margin-bottom: 10px;
    }
    p {
      color: $--color-text-regular;
    }
  }
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
}
</style>
